export default __webpack_public_path__ + "ico_checkmark_green.svg";